import { ScreenTemplateItem } from './controlbar';

export const templateItemsDev: ScreenTemplateItem[] = [
  {
    id: 't9op1d3dv2e29dw38p897drx',
    title: 'Client onboarding',
    icon: 'CLICK',
    description:
      'Lorem ipsum dolor sit amet, consetur adipiscing elit. Cras quis nisi orci. Lorem ipsum dolor sit amet, consectr.',
  },
  {
    id: 'dln7vtlkxz0b7zis5xzmygfmg',
    title: 'Sales onboarding',
    icon: 'PROCESS',
    description:
      'Lorem ipsum dolor sit amet, consetur adipiscing elit. Cras quis nisi orci. Lorem ipsum dolor sit amet, consectr .',
  },
  {
    id: 'd5t3pxjtw704xmdxri69rwna4',
    title: 'Collaboration onbording',
    icon: 'HANDSHAKE',
    description:
      'Lorem ipsum dolor sit amet, consetur adipiscing elit. Cras quis nisi orci. Lorem ipsum dolor sit amet, consectr.',
  },
  {
    id: '9w31qfmetzx8bn5r5piul4r4c',
    title: 'Goal obnboarding',
    icon: 'GOAL',
    description:
      'Lorem ipsum dolor sit amet, consetur adipiscing elit. Cras quis nisi orci. Lorem ipsum dolor sit amet, consectr.',
  },
];

export const templateItemsProd: ScreenTemplateItem[] = [];
